import React from "react";
import ThreeContainerSection from "./ThreeContainerSection";
import Link from "next/link";
const InforSecondSection = ({ setSnpKitPopup, setOpenKitAncestry, handleAddKitProduct, scrollhandleClick, FormulahandleAddKitProduct, Avaible_products, FormulahandleAddKitProductAncestry }) => {
  return (
    <>
      <h3>Do you have the data required for us to formulate? </h3>

      <div className="find-out-button-section">

        <a className="find-out-button" onClick={() => setSnpKitPopup(true)}>Click here to find out</a>

      </div>
      <ThreeContainerSection setSnpKitPopup={setSnpKitPopup} setOpenKitAncestry={setOpenKitAncestry} handleAddKitProduct={handleAddKitProduct}
        FormulahandleAddKitProduct={FormulahandleAddKitProduct} Avaible_products={Avaible_products} FormulahandleAddKitProductAncestry={FormulahandleAddKitProductAncestry} />      <div className="second-section-main">
        <div className="second-section-left-image">
          <img src="/images/second_section_left_image-_s.jpg" />
        </div>
        <div className="second-section-right-content">

          <p>Because of the completely personalized nature of <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link>, we normally require customers to take our DNA test before they can order their custom formula – a <em>process that costs $297 and can take up to 6 weeks.</em></p>

          <p>Yet, if you've already explored genetic testing with providers like <span className="txt-undrline">23andMe or Ancestry.com,</span>
            or have access to your genetic data including these <a style={{ textDecoration: "underline", cursor: "pointer" }}
              onClick={() => setSnpKitPopup(true)}>SNPs</a> – you can <b>skip the line</b>
            and get your custom <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> supplement delivered to your doorstep in 3 weeks or less.</p>

          <h4>And save $178 while you’re at it!</h4>

          <p><span className="txt-undrline">For just $119</span>, you can enter your existing data from one of the providers below,
            and we’ll analyze your genetic markers, revealing potential hidden genetic vulnerabilities that may be contributing to your health challenges,
            and unlock your precision nutritional formulation.</p>

          <p>And since you’ll be bypassing our normal lab testing process, you’ll get your <b>Premium C.O.D.E. Report, Summary DNA Health Report</b> and personalized <b>Supplement Facts panel</b> <em>in a matter of seconds…</em></p>

        </div>
      </div>

      <p>Meaning, we can start formulating your <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> immediately.</p>

      <p><b>Look – if you’ve <span className="txt-undrline ">invested in genetic testing already</span></b>, you likely already possess <a style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => setSnpKitPopup(true)}>the data we need</a> to help you get back to feeling your best.</p>

      <p><em>Don't let the potential of your DNA results sit on a shelf!</em></p>

      <p>That information holds the highlights of your genetic strengths, and more importantly, can guide you on where to focus your attention, helping you save time and money…</p>

      <p><b>By turning them into actionable solutions and supporting your unique genetic vulnerabilities.</b></p>
    </>
  )
}

export default InforSecondSection;